import React from 'react';
import './App.css';
import { BrowserRouter, Route } from 'react-router-dom';
import HomePage from './components/homePage/homePage';
import Alerts from './components/alerts/alerts';
import Invoices from './components/invoices/invoices';
import MIS from './components/mis/mis';
import QRScanner from './components/qr/qrScanner';
import NavigationBar from './components/navigation/bottomNavigationBar/navigationBar';
import Layout from './components/layout/layout';
import Feedback from './components/feedback/feedback';
import { UserContext } from './components/context/userContext';
import { useAuth } from './components/context/user';
import { useBusiness } from './components/context/business';
import { useBusinessHierarchy } from './components/context/businessHierarchy';
import Intro from './components/intro/intro';
import 'react-toastify/dist/ReactToastify.css';
import { StyledToastContainer } from './styles';
import { ErrorBoundary } from "./components/errorBoundary";

const App = ({
  email,
  isMigratedToAuthz3
}: { email: any, isMigratedToAuthz3: boolean }) => {
  const { auth, state } = useAuth();

  const {
    orgId,
    businessLevel,
    businessDetails,
    businessName,
    pageName,
    EWB_ENABLED,
  } = useBusiness();

  const {
    businessHierarchy,
    business
  } = useBusinessHierarchy(isMigratedToAuthz3);

  const value = {
    auth,
    state,
    orgId,
    businessLevel,
    businessDetails,
    businessHierarchy,
    business,
    businessName,
    pageName,
    EWB_ENABLED,
    email,
  };

  window.oncontextmenu = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    return false;
  };
  return (
    <ErrorBoundary>
    <BrowserRouter>
      <Route path="/intro" exact={true} component={Intro} />
      <UserContext.Provider value={value}>
        <Layout>
          <Route path="/feedback" component={Feedback} />
          <Route path="/alerts" component={Alerts} />
          <Route path="/invcompliance" component={Invoices} />
          <Route path="/inv" component={Invoices} />
          <Route path="/qr" component={QRScanner} />
          <Route path="/mis" component={MIS} />
          <Route path="/" exact={true} component={QRScanner} />
        </Layout>
        {window.location.pathname !== '/feedback' && <NavigationBar />}
      </UserContext.Provider>
      <StyledToastContainer
        hideProgressBar
        newestOnTop={true}
        closeOnClick
        rtl={false}
      />
    </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
